import { useRef } from 'react'
import { mappedArray } from '@10000/common'
import { useWindowSize } from '@10000/react'
import { Box } from '.'

const letterWidths = mappedArray(26, i => {
  const element = document.createElement('span')
  element.style.position = 'absolute'
  element.style.top = '-10000px'
  element.style.fontFamily = 'var(--font-alternate)'
  element.style.fontSize = '24px'
  element.style.fontWeight = '600'
  element.style.letterSpacing = '0'
  element.innerText = String.fromCharCode(65 + i)
  document.body.appendChild(element)
  const width = element.getBoundingClientRect().width
  document.body.removeChild(element)
  return width
})

const letterAngles = (word, radius) => word.toUpperCase().split('').reduce(
  (result, letter, i) => {
    // we want TOA from SOH-CAH-TOA
    const opposite = letterWidths[letter.charCodeAt(0) - 65] || 10
    const adjacent = Math.max(radius || 400, 400)
    const letterAngle = Math.atan(opposite / adjacent) * (180 / Math.PI)
    return result.concat(letterAngle + result[i])
  },
  [0]
)
export const CircleHeadings = ({ size = '100%', headings, values, opacity, showAll, ...props }) => {
  const container = useRef()
  const width = container.current?.clientWidth

  useWindowSize()

  return (
    <Box
      container
      justifyContent="center"
      width={size}
      height={size}
      maxWidth={size}
      maxHeight={size}
      aspect="1/1"
      m={25}
      r="50%"
      opacity={opacity}
      transition={1}
      className="circle-headings"
      ref={container}
      {...props}
    >
      {headings.map((heading, i) =>
        letterAngles(heading, width / 2.5).map((angle, j, angles) => {
          const segmentWidth = 360 / headings.length
          const totalWordAngle = angles[angles.length - 1]
          const startAngle = (segmentWidth * (i + 0.5)) - (totalWordAngle / 2)

          return <span
            key={j}
            style={{
              display: 'flex',
              color: 'white',
              fontFamily: 'var(--font-alternate)',
              fontWeight: 600,
              fontSize: width / 40 || 24,
              justifyContent: 'start',
              position: 'absolute',
              height: '50%',
              width: 15,
              lineHeight: 1,
              transformOrigin: 'bottom center',
              transform: `rotate(${startAngle + angle}deg)`,
              opacity: (showAll || (typeof values[i] === 'number' && !isNaN(values[i])) || values[i] instanceof Array) ? 1 : 0,
              transition: 'opacity 0.5s'
            }}
          >
            {heading[j]}
          </span>
        })
      )}
    </Box>
  )
}
